import * as types from '../../actionTypes'

export const fetchingPreviewDeleteUser = () => ({
  type: types.FETCHING_PREVIEW_DELETE_USER,
})

export const fetchingPreviewDeleteUserSuccess = previewDeleteUserResults => ({
  type: types.FETCHING_PREVIEW_DELETE_USER_SUCCESS,
  previewDeleteUserResults,
})

export const fetchingPreviewDeleteUserError = previewDeleteUserError => ({
  type: types.FETCHING_PREVIEW_DELETE_USER_ERROR,
  previewDeleteUserError,
})
export const deletingUser = () => ({
  type: types.DELETING_USER,
})

export const deletingUserSuccess = deleteUserResults => ({
  type: types.DELETING_USER_SUCCESS,
  deleteUserResults,
})

export const deletingUserError = deleteUserError => ({
  type: types.DELETING_USER_ERROR,
  deleteUserError,
})
